module.exports = __webpack_public_path__ + "img/ic_warning.6a8598e1.svg";